import React, { useState } from 'react';
import cx from 'classnames';

import { useConfig } from '@xingternal/hops';

import GoogleMaps, { Coords } from 'google-map-react';

import marker from './marker.svg';

import styles from './Map.css';
import './GoogleMapsOverride.css?global';


const options = {
  disableDefaultUI: true,
  draggable: false,
  zoomControl: false,
  scrollwheel: false,
  disableDoubleClickZoom: false,
  draggableCursor: 'default',
  clickableIcons: false,
};

const Marker = () => (
  <div className={styles.marker}>
    <img src={marker} alt="marker" />
  </div>
);

const Map = ({ lat, lng }:  Coords ) => {
  const config = useConfig();
  const [loaded, setLoaded] = useState(false);

  const onGoogleApiLoaded = (maps: any) => {
    if (maps.map) {
      // maps.map.panBy(0, 40);
      setLoaded(true);
    }
  };

  return (
    <div className={cx(styles.mapWrapper, { [styles.mapLoaded]: loaded })} data-testid="maps-container">
      <GoogleMaps
        bootstrapURLKeys={{
          key:
            config.googleMapsApiKey ||
            'AIzaSyA7YwLuHjNLKRSzYbAo2FwH2iEeLoBn9BA',
        }}
        defaultCenter={{ lat, lng }}
        defaultZoom={14}
        options={options}
        onGoogleApiLoaded={onGoogleApiLoaded}
        yesIWantToUseGoogleMapApiInternals={true}
      >
        {loaded && <Marker />}
      </GoogleMaps>
    </div>
  );
};

export default Map;
